<script setup lang="ts">
import type { StickerFill, StickerTilt } from './SfgSticker.vue'

const props = withDefaults(defineProps<{
  fill?: StickerFill
  /** Accepts a number (px) or any CSS length string, including clamp(). */
  size?: number | string
  stroke?: StickerFill
  tilt?: StickerTilt
}>(), {
  fill: 'yellow',
  size: 80,
  stroke: 'ink',
  tilt: 1,
})

const fillVar = computed(() => `var(--color-brand-${props.fill})`)
const strokeVar = computed(() => `var(--color-brand-${props.stroke})`)
const sizeCss = computed(() => (typeof props.size === 'number' ? `${props.size}px` : props.size))
</script>

<template>
  <svg
    :style="{
      width: sizeCss,
      height: sizeCss,
      transform: `rotate(var(--sticker-rotate-${props.tilt}))`,
      filter: 'drop-shadow(0 4px 0 rgba(0, 0, 0, 0.7))',
    }"
    viewBox="0 0 100 100"
  >
    <polygon
      points="50,5 62,38 97,38 68,60 79,95 50,73 21,95 32,60 3,38 38,38"
      :fill="fillVar"
      :stroke="strokeVar"
      stroke-width="3"
      stroke-linejoin="round"
    />
  </svg>
</template>
